export default __webpack_public_path__ + "static/O0274-a33f4d1db95f808d40871357f60cf160.png";